export default "__VITE_ASSET__D0c9ldBx__"